import { StyleSheet } from 'aphrodite';
import { Colors } from '../../themes/Colors';

export const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: 'calc(var(--fs-xl)*1.41509434)',
    paddingLeft: 'calc(var(--fs-xl)*1.509434)',
    paddingRight: 'calc(var(--fs-xl)*1.509434)',
    backgroundColor: Colors.white,
    paddingBottom: 'calc(var(--fs-xl)*3.86792453)',
    height: '100%'
  }
});
